<script lang="ts">import { Text } from "@infinitro/text";
import { onDestroy, onMount } from "svelte";
export let endDate = null;
export let label;
export let textAlign = "start";
export let type = "body";
export let titleSize = "h1";
export let titleWeight = "regular";
export let subtitleSize = "large";
export let subtitleWeight = "regular";
export let bodySize = "medium";
export let bodyWeight = "regular";
export let timeRemaining = "00:00:00:00";
export let customStyle = "";
let interval = null;
function parseUtcStrict(iso) {
	if (/[zZ]|[+\-]\d{2}:\d{2}$/.test(iso)) return new Date(iso).getTime();
	const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d+))?)?$/);
	if (!m) return new Date(iso + "Z").getTime();
	const [, Y, M, D, h, mn, ss = "0", frac = "0"] = m;
	const ms = frac.padEnd(3, "0").slice(0, 3);
	return Date.UTC(+Y, +M - 1, +D, +h, +mn, +ss, Number(ms));
}
function calculateTimeRemaining() {
	if (!endDate) {
		timeRemaining = "00:00:00:00";
		return;
	}
	const endTime = parseUtcStrict(String(endDate));
	const now = Date.now();
	const diffMs = endTime - now;
	if (diffMs <= 0) {
		timeRemaining = "00:00:00:00";
		if (interval) {
			clearInterval(interval);
			interval = null;
		}
		return;
	}
	const totalSeconds = Math.ceil(diffMs / 1e3);
	const days = Math.floor(totalSeconds / 86400);
	const remDay = totalSeconds % 86400;
	const hours = Math.floor(remDay / 3600);
	const remHour = remDay % 3600;
	const minutes = Math.floor(remHour / 60);
	const seconds = remHour % 60;
	const dd = String(days).padStart(2, "0");
	const hh = String(hours).padStart(2, "0");
	const mm = String(minutes).padStart(2, "0");
	const ss = String(seconds).padStart(2, "0");
	timeRemaining = `${dd}:${hh}:${mm}:${ss}`;
}
onMount(() => {
	calculateTimeRemaining();
	interval = setInterval(calculateTimeRemaining, 1e3);
});
onDestroy(() => {
	if (interval) {
		clearInterval(interval);
	}
});
</script>

{#if endDate}
	<Text
		{textAlign}
		{type}
		{titleSize}
		{titleWeight}
		{subtitleSize}
		{subtitleWeight}
		{bodySize}
		{bodyWeight}
		{customStyle}
	>
		{#if label}
			{label}:
		{/if}
		<span class="highlight-text">{timeRemaining}</span>
	</Text>
{/if}

<style>
	.highlight-text {
    font-weight: 700;
    color: var(--color-highlight-2)
}
</style>
